var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7609 3.64219C23.7609 3.64219 23.5266 1.9875 22.8047 1.26094C21.8906 0.304688 20.8688 0.3 20.4 0.24375C17.0438 -1.3411e-07 12.0047 0 12.0047 0H11.9953C11.9953 0 6.95625 -1.3411e-07 3.6 0.24375C3.13125 0.3 2.10938 0.304688 1.19531 1.26094C0.473438 1.9875 0.24375 3.64219 0.24375 3.64219C0.24375 3.64219 0 5.5875 0 7.52813V9.34687C0 11.2875 0.239062 13.2328 0.239062 13.2328C0.239062 13.2328 0.473437 14.8875 1.19062 15.6141C2.10469 16.5703 3.30469 16.5375 3.83906 16.6406C5.76094 16.8234 12 16.8797 12 16.8797C12 16.8797 17.0438 16.8703 20.4 16.6313C20.8688 16.575 21.8906 16.5703 22.8047 15.6141C23.5266 14.8875 23.7609 13.2328 23.7609 13.2328C23.7609 13.2328 24 11.2922 24 9.34687V7.52813C24 5.5875 23.7609 3.64219 23.7609 3.64219ZM9.52031 11.5547V4.80937L16.0031 8.19375L9.52031 11.5547Z",
    fill: "#98A2B3",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.5737417c392fed559209e74901eed826.svg";
export { ForwardRef as ReactComponent };